import script from "./FooterM.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterM.vue?vue&type=script&setup=true&lang=js"

import "./FooterM.vue?vue&type=style&index=0&id=0e55126a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e55126a"]])

export default __exports__